/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';
import { media } from '@atlassian/bitkit-responsive';

import { TableHeader } from 'src/components/pageable-table';
import RelativeLink from 'src/components/relative-link';
import { link, overflowEllipsis } from 'src/styles/mixins';

export const RepositoryContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const RepositoryRow = styled.tr({
  height: '64px',
  '&:hover, &:focus': {
    backgroundColor: token('elevation.surface.raised.hovered'),
    boxShadow: token('elevation.shadow.raised'),
    borderRadius: token('radius.small'),
  },
});

export const RepositoryInfo = styled.div({
  padding: `${token('space.050')} ${token('space.100')}`,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const RepositoryLink = styled(RelativeLink)(link);

export const CenteredColumn = styled.td({
  textAlign: 'center',
  padding: token('space.300'),
});

export const TableHeaderPrivateColumn = styled.th({
  width: '34px',
});

export const PaginationContainer = styled.div({
  padding: `${token('space.100')} 0`,
  marginBottom: token('space.400'),
});

export const DateWrapper = styled.small(
  {
    display: 'none',
    margin: 0,
    color: token('color.text.subtlest'),
  },
  media.upToSmall(`
    display: block;
    ${overflowEllipsis('140px')};
  `)
);

export const ProjectNameUpdatedContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  '& a, & a:hover, & a:focus': {
    color: token('color.text.subtlest'),
  },
});

export const Info = styled.small(
  {
    margin: `${token('space.025')} ${token('space.025')} 0 0`,
    display: 'block',
  },
  overflowEllipsis()
);

export const ForkInfo = styled.small(
  {
    margin: `${token('space.025')} ${token('space.025')} 0 0`,
    display: 'block',
    color: token('color.text.subtlest'),
  },
  overflowEllipsis()
);

export const DescriptionWrapper = styled.div({
  color: token('color.text.subtlest'),
});

export const RepositoryInfoTableHeader = styled(TableHeader)(
  media.upToSmall(`
    width: 70%;
  `)
);

export const BuildStatusTableHeader = styled(TableHeader)({
  overflow: 'visible',
});
